<template>
  <v-container grid-list-md class="px-2 campaign">
    <v-layout row wrap>
      <v-flex md12>
        <v-layout row justify-space-between>
          <v-flex headline py-0>Painel de acesso</v-flex>
        </v-layout>
        <v-divider class="my-3"></v-divider>
      </v-flex>
      <v-flex xs12 md12 pt-0>
        <v-data-table
          :headers="headers"
          :items="users"
          :pagination.sync="pagination"
          :total-items="totalUsers"
          :loading="loading"
          disable-initial-sort
          :no-data-text="loading ? 'Aguarde...' : 'Sem resultados'"
          rows-per-page-text="Registros por página"
          class="elevation-1"
        >
          <template v-slot:items="user">
            <td>{{ user.item.name }}</td>
            <td>{{ user.item.email }}</td>
            <td>{{ user.item.profile }}</td>
            <td class="pl-0" style="text-align: right">
              <v-btn @click="openFarmsDialog(user.item)" outline depressed small color="primary">Acessos</v-btn>
            </td>
          </template>
          <template
            slot="pageText"
            slot-scope="item"
          >
            {{item.pageStart.toString().padStart(2, '0')}} - {{item.pageStop.toString().padStart(2, '0')}} de {{item.itemsLength.toString().padStart(2, '0')}}
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <Farms ref="Farms"/>
  </v-container>
</template>

<script>
import Farms from './farm';

export default {
  components: {
    Farms
  },
  data() {
    return {
      totalUsers: 0,
      users: [],
      loading: true,
      pagination: {},
      headers: [
        { text: "NOME COMPLETO", align: "left", value: "name" },
        { text: "E-MAIL", align: "left", value: "email" },
        { text: "PERFIL", align: "left", value: "profile" },
        { text: "", sortable: false }
      ]
    }
  },
  watch: {
    pagination: {
      handler() {
        if (!this.loading) {
          this.getUsers()
        }        
      }
    }
  },
  mounted() {
    this.getUsers()
  },
  methods: {
    getUsers() {
      var self     = this;
      self.loading = true;
      self.$http
        .get("/v1/adm/access/user", {
          params: self.pagination
        })
        .then(function(r) {
          self.users      = r.data.users
          self.totalUsers = r.data.total
          self.loading    = false
        });
    },
    openFarmsDialog(user) {
      this.$refs.Farms.openDialog(user);
    }
  }
};
</script>

<style lang="scss">
</style>
